export default {
  downloadSuccess: 'Log downloaded.',
  downloadFail: 'Error log download failed. Please try again.',
} as const;
